import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Spinner, Markdown } from "components/common";
import { Alert } from "components/bootstrap";
import useWorkflowPrompt from "aiagent/AgentWorkflows/hooks/useWorkflowPrompt";
const PromptContent = styled.div`
  overflow-wrap: anywhere;

  pre {
    white-space: pre-wrap;
  }
`;
const WorkflowPrompt = ({ workflowId }) => {
  const { t } = useTranslation("enterprise_ai");
  const { data: prompt, isLoading, isError, error } = useWorkflowPrompt(workflowId);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isLoading && /* @__PURE__ */ React.createElement(Spinner, { text: t("workflow_prompt.loading") }), isError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: t("workflow_prompt.load_failed") }, error instanceof Error ? error.message : t("common_texts.unknown_error")), !isLoading && !isError && /* @__PURE__ */ React.createElement(PromptContent, null, prompt ? /* @__PURE__ */ React.createElement(Markdown, { text: prompt }) : t("workflow_prompt.none")));
};
export default WorkflowPrompt;
